
import { PuttSituation } from "@/types/golf";
import ScoreButton from "./ScoreButton";

interface ScoreButtonsProps {
  situation: PuttSituation;
  onScoreSelect: (points: number) => void;
  isTestComplete: boolean;
}

const ScoreButtons = ({ situation, onScoreSelect, isTestComplete }: ScoreButtonsProps) => {
  return (
    <div className="grid grid-cols-1 gap-2 md:gap-3 mb-4">
      {situation.scoring.map((score) => (
        <ScoreButton
          key={score.points}
          points={score.points}
          condition={score.condition}
          onClick={onScoreSelect}
          disabled={isTestComplete}
        />
      ))}
    </div>
  );
};

export default ScoreButtons;
